<div class="unit-details-pictures-section-container display-flex grid-gap-8">
  <div class="display-flex flex-column w-50 grid-gap-8">
    <div class="label-caps">Photos ({{ unitPhotos?.length || 0 }})</div>
    <div class="display-flex align-items-center grid-gap-8" *ngIf="!readOnly && form">
      <app-attachment
        [acceptedFormats]="acceptedFormats"
        [keepSelection]="false"
        (attachmentItemEvent)="fileUploaded($event, UnitAttachmentType.Photo)"
        [allowLink]="false"
      ></app-attachment>
    </div>
    <div class="display-flex flex-wrap grid-gap-8 position-relative">
      <div class="position-absolute w-100 h-100" *ngIf="unitPhotos?.length > displayedUnitPhotos?.length">
        <div class="display-flex justify-content-center align-items-center w-100 h-100">
          <button mat-stroked-button color="primary" class="view-all-button" (click)="showUnitPictures()">
            View all ({{ unitPhotos?.length }})
          </button>
        </div>
      </div>
      <app-picture
        *ngFor="let item of displayedUnitPhotos"
        [picture]="item"
        (selectPictureEvent)="showUnitPictures()"
      ></app-picture>
    </div>
  </div>
  <div class="display-flex flex-column w-50 grid-gap-8">
    <div class="label-caps">Floor plan ({{ unitFloorPlan?.length || 0 }})</div>
    <div class="display-flex align-items-center grid-gap-8" *ngIf="!readOnly && form">
      <app-attachment
        [acceptedFormats]="acceptedFormats"
        [keepSelection]="false"
        (attachmentItemEvent)="fileUploaded($event, UnitAttachmentType.FloorPlan)"
        [allowLink]="false"
      ></app-attachment>
    </div>
    <div class="display-flex flex-wrap grid-gap-8 position-relative">
      <div class="position-absolute w-100 h-100" *ngIf="unitFloorPlan?.length > displayedUnitFloorPlan?.length">
        <div class="display-flex justify-content-center align-items-center w-100 h-100">
          <button mat-stroked-button color="primary" class="view-all-button" (click)="showUnitFloorPlans()">
            View all ({{ unitFloorPlan?.length }})
          </button>
        </div>
      </div>
      <app-picture
        *ngFor="let item of displayedUnitFloorPlan"
        [picture]="item"
        (selectPictureEvent)="showUnitFloorPlans()"
      ></app-picture>
    </div>
  </div>
</div>

<ng-template #addPicturesBtnTemplate>
  <div class="display-flex align-items-center grid-gap-8">
    <ng-container [ngTemplateOutlet]="buttonIconTemplate"></ng-container>
    <span>Add photos</span>
    <ng-container [ngTemplateOutlet]="buttonSpinnerTemplate"></ng-container>
  </div>
</ng-template>

<ng-template #addFloorPlanBtnTemplate>
  <div class="display-flex align-items-center grid-gap-8">
    <ng-container [ngTemplateOutlet]="buttonIconTemplate"></ng-container>
    <span>Add floor plan</span>
    <ng-container [ngTemplateOutlet]="buttonSpinnerTemplate"></ng-container>
  </div>
</ng-template>

<ng-template #buttonIconTemplate>
  <app-icon
    [iconColor]="fileUploadInProgress ? EColorPalette.cGray7 : EColorPalette.cGreen3"
    [iconHeight]="24"
    [iconWidth]="24"
    [svg]="EIcon.PLUS"
  ></app-icon>
</ng-template>

<ng-template #buttonSpinnerTemplate>
  <mat-spinner *ngIf="fileUploadInProgress" color="accent" diameter="20"></mat-spinner>
</ng-template>
